import { render } from "./ProductRecommendationServiceParameter.vue?vue&type=template&id=f5a0c712&scoped=true"
import script from "./ProductRecommendationServiceParameter.vue?vue&type=script&lang=ts"
export * from "./ProductRecommendationServiceParameter.vue?vue&type=script&lang=ts"

import "./ProductRecommendationServiceParameter.vue?vue&type=style&index=0&id=f5a0c712&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f5a0c712"

export default script